import "../../../../css/GlobalStyles.css";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { Colors } from "../../../../utils/colors";
import MarkitPlusActionButton from "../../../../components/Subscription/MarkitPlusActionButton";
import CreatorModePanelWrapper from "../../../../components/CreatorDashboard/CreatorModePanelWrapper";
import HelpModal from "../../../../components/Containers/HelpModal";
import StandardBorderedContainer from "../../../../components/Containers/StandardBorderedContainer";
import { HorizontalDivider } from "../../../../components/Dividers/HorizontalDivider";
import { EventbritePanelSection } from "../../../../components/CreatorDashboard/CreatorProfile/Integration/EventbritePanelSection";
import { ShowclixPanelSection } from "../../../../components/CreatorDashboard/CreatorProfile/Integration/ShowclixPanelSection";
import { InstagramPanelSection } from "../../../../components/CreatorDashboard/AutoDM/Instagram/InstagramPanelSection";
import { FacebookPanelSection } from "../../../../components/CreatorDashboard/AutoDM/Facebook/FacebookPanelSection";
import { GoogleCalendarPanelSection } from "../../../../components/CreatorDashboard/CreatorProfile/Integration/GoogleCalendarPanelSection";
import { WhatsAppPanelSection } from "../../../../components/CreatorDashboard/CreatorProfile/Integration/WhatsAppPanelSection";
import { McpPanelSection } from "../../../../components/CreatorDashboard/CreatorProfile/Integration/McpPanelSection";
import { MarkitApiPanelSection } from "../../../../components/CreatorDashboard/CreatorProfile/Integration/MarkitApiPanelSection";
import { PlanTypeV4 } from "@markit/common.types";
import { getAccountState } from "../../../../redux/slices/accountSlice";

const ABOUT_INTEGRATIONS_ITEMS = [
  {
    icon: "fa-solid:plug",
    text: "Integrations connect Markit to the platforms you already use. Extend Markit's capabilities and help grow your audience.",
  },
  {
    icon: "ion:sync-sharp",
    text: "Convert your social media followers and customers into contacts that you can send text messages to.",
  },
  {
    icon: "ion:sparkles",
    text: "Connect AI tools like Claude, or build your own integrations with the Markit API.",
  },
  {
    icon: "ion:close-circle",
    text: "Disconnect or pause your integrations at any time.",
  },
];

const IntegrationsPanel = () => {
  const { accountData } = useSelector(getAccountState).account;
  const [helpModal, setHelpModal] = useState(false);

  const styles = {
    overallContainerView: {
      backgroundColor: Colors.WHITE,
      flex: 1,
      width: "100%",
      minHeight: 237,
      borderRadius: 20,
      paddingBlock: 14,
    },
  };

  return (
    <CreatorModePanelWrapper
      title="Integrations"
      headerRight={
        <div className="AlignedRow" style={{ gap: 14 }}>
          <MarkitPlusActionButton planType={PlanTypeV4.PRO} />
        </div>
      }
    >
      <div
        className="ColumnNormal"
        style={{ padding: 30, paddingBottom: 100, gap: 30, flexWrap: "wrap" }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
            gap: 30,
          }}
        >
          <InstagramPanelSection />
          <FacebookPanelSection />
          <GoogleCalendarPanelSection />
          {/* TEMP(MARK-3954): admin-only until WhatsApp launches */}
          {accountData.isAdmin ? <WhatsAppPanelSection /> : null}
          <McpPanelSection />
          <MarkitApiPanelSection />
          <ShowclixPanelSection />
          <EventbritePanelSection />
          <StandardBorderedContainer
            containerStyles={styles.overallContainerView}
          >
            <div className="ColumnNormal">
              <div className="AlignedRowSpaced" style={{ paddingInline: 14 }}>
                <span className="bodyMedium">About Integrations</span>
                <div
                  className="AlignedRowSelect"
                  style={{ gap: 2 }}
                  onClick={() => setHelpModal(true)}
                >
                  <span style={{ fontSize: 12, fontWeight: 500 }}>
                    Don&apos;t see an integration you want?
                  </span>
                  <Icon
                    icon="ion:arrow-forward"
                    height={15}
                    style={{
                      transform: "rotateY(0deg) rotate(-45deg)",
                      marginBottom: -1,
                    }}
                  />
                </div>
              </div>
              <HorizontalDivider altMargin={14} />
              <div
                className="ColumnNormal"
                style={{ gap: 14, paddingInline: 14 }}
              >
                {ABOUT_INTEGRATIONS_ITEMS.map((item) => (
                  <div
                    key={item.icon}
                    className="AlignedRow"
                    style={{ gap: 14, paddingRight: 14 }}
                  >
                    <div>
                      <Icon icon={item.icon} height={25} width={25} />
                    </div>
                    <span className="bodyRegular">{item.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </StandardBorderedContainer>
        </div>
        <HelpModal showModal={helpModal} setShowModal={setHelpModal} />
      </div>
    </CreatorModePanelWrapper>
  );
};

export default IntegrationsPanel;
